import React, { useState, useEffect } from 'react';
import { useAuth } from '../context/AuthContext';
import { useNavigate } from 'react-router-dom';

const API = "/api";

export default function AdminUsers() {
  const { authFetch, user, logout } = useAuth();
  const navigate = useNavigate();
  const [users, setUsers] = useState([]);
  const [showForm, setShowForm] = useState(false);
  const [form, setForm] = useState({ email: '', username: '', password: '', role: 'viewer' });
  const [error, setError] = useState('');

  const loadUsers = () => {
    authFetch(`${API}/auth/users`)
      .then(r => r.json())
      .then(d => setUsers(d.users || []))
      .catch(() => {});
  };

  useEffect(loadUsers, []);

  const handleCreate = async (e) => {
    e.preventDefault();
    setError('');
    const res = await authFetch(`${API}/auth/users`, {
      method: 'POST',
      body: JSON.stringify(form),
    });
    if (res.ok) {
      setShowForm(false);
      setForm({ email: '', username: '', password: '', role: 'viewer' });
      loadUsers();
    } else {
      const err = await res.json().catch(() => ({}));
      setError(err.detail || 'Errore nella creazione');
    }
  };

  const handleDeactivate = async (userId) => {
    if (!window.confirm('Disattivare questo utente?')) return;
    await authFetch(`${API}/auth/users/${userId}`, { method: 'DELETE' });
    loadUsers();
  };

  return (
    <div className="admin-page">
      <header className="header">
        <div className="header-left">
          <span className="logo-text" style={{ cursor: 'pointer' }} onClick={() => navigate('/chat')}>ERMENE</span>
          <span className="logo-subtitle">Gestione Utenti</span>
        </div>
        <div className="header-right">
          <span className="header-subtitle">{user?.username}</span>
          <button className="theme-toggle" onClick={logout}>Esci</button>
        </div>
      </header>

      <div className="admin-content">
        <div className="admin-toolbar">
          <h2>Utenti ({users.length})</h2>
          <button onClick={() => setShowForm(!showForm)}>
            {showForm ? 'Annulla' : 'Nuovo utente'}
          </button>
        </div>

        {showForm && (
          <form className="admin-form" onSubmit={handleCreate}>
            <input placeholder="Email" type="email" required value={form.email} onChange={e => setForm({ ...form, email: e.target.value })} />
            <input placeholder="Username" required value={form.username} onChange={e => setForm({ ...form, username: e.target.value })} />
            <input placeholder="Password (min 8 car.)" type="password" required minLength={8} value={form.password} onChange={e => setForm({ ...form, password: e.target.value })} />
            <select value={form.role} onChange={e => setForm({ ...form, role: e.target.value })}>
              <option value="viewer">Viewer</option>
              <option value="operator">Operator</option>
              <option value="admin">Admin</option>
            </select>
            <button type="submit">Crea</button>
            {error && <span className="login-error">{error}</span>}
          </form>
        )}

        <table className="admin-table">
          <thead>
            <tr>
              <th>Username</th>
              <th>Email</th>
              <th>Ruolo</th>
              <th>Attivo</th>
              <th>Ultimo login</th>
              <th></th>
            </tr>
          </thead>
          <tbody>
            {users.map(u => (
              <tr key={u.user_id} className={!u.is_active ? 'inactive' : ''}>
                <td>{u.username}</td>
                <td>{u.email}</td>
                <td><span className={`role-badge role-${u.role}`}>{u.role}</span></td>
                <td>{u.is_active ? 'Si' : 'No'}</td>
                <td>{u.last_login ? new Date(u.last_login).toLocaleString('it-IT') : '-'}</td>
                <td>
                  {u.is_active && u.user_id !== user?.user_id && (
                    <button className="btn-small" onClick={() => handleDeactivate(u.user_id)}>Disattiva</button>
                  )}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}
